/*當前頁面活動開始結束*/
theCollectionTime();
function theCollectionTime(){
	var stime=$("#CollectionSection").attr("stime");
	var etime=$("#CollectionSection").attr("etime");
	var timeError=timecContrast(stime,etime);
    if(timeError){
      if(timeError=='Coming soon!'){
         $("#collection-discount-more .rule-code").hide();
        $("#collection-discount-more .rule-p").css({"border":"0px"})
        $(".display-top-rule>div").css({"border":"0px"})
      }else{
      	layer.confirm(timeError, {
          btn: ['confirm'], //按钮
          time: 2000, //2s后自动关闭
          shadeClose: true, //开启遮罩关闭
          btn: ['confirm'], //按钮
          title: 'information'
        }, function(){
          $(location).attr('href', "/pages/discount");
        });
      }
      
    }
	
	
}

function timecContrast(stime,etime){
    stime=stime.replace(/-/g,"/");
    etime=etime.replace(/-/g,"/");
	var dN=new Date()
    var timestampN=dN.getTime();
	var timeError="";
	if(stime){
		var dS=new Date(stime+"  EDT");
    	var timestampS=dS.getTime();
		if(timestampS>timestampN){
			timeError="Coming soon!";
		}
	}
	if(etime){
		var dE=new Date(etime+"  EDT");
    	var timestampE=dE.getTime();
		if(timestampE<timestampN){
			timeError="Uh-oh!The deals are expired.";
		}
	}
    return  timeError;
}
/*其他活動開始結束*/
theCollectionsTime()
function theCollectionsTime(){
    $("#sortBy option").each(function(key,val){
          var stime=$(this).attr("stime");
          var etime=$(this).attr("etime");
          var timeError=timecContrast(stime,etime); 
      
        
          if(timeError=="Uh-oh!The deals are expired."){
              $(this).remove();                     
          }else if(timeError=='Coming soon!'){
          	  $(this).append("(Coming soon)")
          }
    })                               		
} 

$("#sortBy").change(function(){
	var url=$(this).val();
   $(location).attr('href', url);
})

//复制折扣碼
var clipboard = new Clipboard('.copyBtn');
$(".copyBtn").click(function(){
    layer.open({
      title: 'information',
      content: '<div class="layer-code"><p>Congratulation!Use the code at checkout</p></div>',
      time: 2000, //2s后自动关闭
      shadeClose: true, //
      btn: ['confirm'] //按钮
    });
})
//计算折扣价格
$(function(){
    $("#CollectionSection .product-card-ul li").each(function(){
    	var price=$(this).find(".money").attr("price");
        price=price*0.01;
        price=price.toFixed(2)
        var discountPrice=price;
        var showOriginalPrice=$("#CollectionSection").attr("showOriginalPrice");
        var discountPrice=price;
        if(showOriginalPrice == 'true'){

        }else{
        	if(price){
              var discountNum=$("#CollectionSection").attr("discountnum");
              var discountType=$("#CollectionSection").attr("discounttype");
              if(discountType=="Fixed amount"){
                discountPrice=parseFloat(price)-parseFloat(discountNum);
                discountPrice=discountPrice.toFixed(2);
              }else if(discountType=='Percentage'){
                discountPrice=price*(1-discountNum*0.01);
                discountPrice=discountPrice.toFixed(3)
                discountPrice=discountPrice*100;
                discountPrice=Math.ceil(discountPrice);
                discountPrice=discountPrice/100;
                discountPrice=discountPrice.toFixed(2);
              }
          }
        }
      $(this).find(".discount-price").html("$"+discountPrice); 
      if(discountPrice==price){
      	$(this).find(".money").hide()
      }
      
    })
})

//筛选start
$(function(){
  $("#screenBox .screenV").click(function(){
  	$(this).addClass("screenV-On").siblings().removeClass("screenV-On");
    discountScreenFun()
  })
  //产品品牌
  var discountBrand={};
  $("#CollectionSection .product-card-ul li").each(function(){
  	 var productBrand=$(this).attr("product_brand");
     if(!discountBrand[productBrand]){
       discountBrand[productBrand]=productBrand;
     }
  })
  $("#screenBox .screen-brand .screenV").each(function(){
  	var productBrand=$(this).html();
    if(!discountBrand[productBrand] && productBrand!="All"){
    	$(this).hide();
    }else{
    	$(this).show();
    }
  })
  //筛选方法
  function discountScreenFun(){
  	var productType0=$("#screenBox .screen-type .screenV-On").html();
    var productBrand0=$("#screenBox .screen-brand .screenV-On ").html();
    
    $("#CollectionSection .product-card-ul li").each(function(){
      var productType=$(this).attr("product-type");
      var product_brand=$(this).attr("product_brand");
      
      var isShow=1;
      if(productType0!="All"){
        if(productType0!=productType){
        	isShow=0;
        }	
      }
      if(productBrand0!="All"){
        if(productBrand0!=product_brand){
        	isShow=0;
        }	
      }
      if(isShow){
      	$(this).show();
      }else{
        $(this).hide();
      }
    	
    })
  }
})
//筛选end

